import { Link } from 'wouter';
import { Tag, Plus } from 'lucide-react';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '../ui/sidebar';

interface CategorySidebarGroupProps {
  categories?: Array<{ _id: string; name: string; color?: string }>;
  currentContextId: string | null;
  activeCategoryId?: string;
  isManageCategoriesActive: boolean;
}

export function CategorySidebarGroup({
  categories,
  currentContextId,
  activeCategoryId,
  isManageCategoriesActive,
}: CategorySidebarGroupProps) {
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Categories</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {categories?.map((category) => {
            const categoryPath = `/context/${currentContextId}/category/${category._id}`;
            const isActive = activeCategoryId === category._id;
            
            return (
              <SidebarMenuItem key={category._id}>
                <SidebarMenuButton asChild isActive={isActive}>
                  <Link to={currentContextId ? categoryPath : '#'}>
                    <Tag
                      className="h-4 w-4"
                      style={{ color: category.color || undefined }}
                    />
                    <span>{category.name}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
          <SidebarMenuItem>
            <SidebarMenuButton 
              asChild 
              isActive={isManageCategoriesActive}
            >
              <Link to={currentContextId ? `/context/${currentContextId}/categories/manage` : '#'}>
                <Plus className="h-4 w-4" />
                <span>Manage Categories</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}